import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './index.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname === "localhost" ? "http://localhost:5000" : "");

const AdminPage = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [username, setUsername] = useState('');
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [editingUser, setEditingUser] = useState(null);
    const [newCredits, setNewCredits] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await axios.post(`${API_BASE_URL}/api/admin/login`, { username, pin });
            if (response.data.success) {
                setIsAdmin(true);
                fetchUsers();
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    const fetchUsers = async () => {
        try {
            console.log("Fetching users...");
            const response = await axios.get(`${API_BASE_URL}/api/admin/users`);
            console.log("Users fetched successfully:", response.data);
            setUsers(response.data.users || []);
        } catch (err) {
            console.error("Fetch users error:", err);
            setError(`Failed to fetch users: ${err.message}`);
        }
    };

    const handleUpdateCredits = async (userId) => {
        try {
            await axios.post(`${API_BASE_URL}/api/admin/update-credits`, { userId, credits: newCredits });
            setEditingUser(null);
            fetchUsers();
        } catch (err) {
            alert('Failed to update credits');
        }
    };

    const filteredUsers = users.filter(user =>
        user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.displayName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.id?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!isAdmin) {
        return (
            <div className="admin-login-container" style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80vh',
                background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)',
                color: '#fff'
            }}>
                <div className="admin-card" style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    padding: '40px',
                    borderRadius: '20px',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                    width: '400px',
                    textAlign: 'center',
                    border: '1px solid rgba(255, 255, 255, 0.18)'
                }}>
                    <h2 style={{ marginBottom: '20px', fontSize: '2rem' }}>Admin Access</h2>
                    <form onSubmit={handleLogin}>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                margin: '10px 0',
                                borderRadius: '10px',
                                border: 'none',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: '#fff',
                                outline: 'none'
                            }}
                        />
                        <input
                            type="password"
                            placeholder="PIN"
                            value={pin}
                            onChange={(e) => setPin(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                margin: '10px 0',
                                borderRadius: '10px',
                                border: 'none',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: '#fff',
                                outline: 'none'
                            }}
                        />
                        {error && <p style={{ color: '#ff4b2b', fontSize: '0.9rem' }}>{error}</p>}
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: '100%',
                                padding: '12px',
                                marginTop: '20px',
                                borderRadius: '10px',
                                border: 'none',
                                background: 'linear-gradient(to right, #6a11cb, #2575fc)',
                                color: '#fff',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                transition: 'transform 0.2s'
                            }}
                        >
                            {loading ? 'Verifying...' : 'Login'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-dashboard" style={{ padding: '40px', minHeight: '100vh', background: '#0a0a0a', color: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
                <h1 style={{ fontSize: '2.5rem', background: 'linear-gradient(to right, #00c6ff, #0072ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                    User Management Dashboard
                </h1>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <input
                        type="text"
                        placeholder="Filter by name or email..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            padding: '12px 20px',
                            borderRadius: '30px',
                            border: '1px solid #333',
                            background: '#1a1a1a',
                            color: '#fff',
                            width: '300px',
                            outline: 'none'
                        }}
                    />
                    <button onClick={fetchUsers} className="refresh-btn" style={{
                        padding: '12px 20px',
                        borderRadius: '30px',
                        background: '#333',
                        color: '#fff',
                        border: 'none',
                        cursor: 'pointer'
                    }}>
                        Refresh
                    </button>
                </div>
            </div>

            {error && <p style={{ color: '#ff4b2b', textAlign: 'center', marginBottom: '20px', background: 'rgba(255,0,0,0.1)', padding: '10px', borderRadius: '5px' }}>{error}</p>}

            <div className="table-container" style={{ background: '#111', borderRadius: '15px', overflow: 'hidden', border: '1px solid #222' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ background: '#1a1a1a', borderBottom: '1px solid #222' }}>
                            <th style={{ padding: '20px' }}>User</th>
                            <th style={{ padding: '20px' }}>Email</th>
                            <th style={{ padding: '20px' }}>Credits</th>
                            <th style={{ padding: '20px' }}>Joined</th>
                            <th style={{ padding: '20px' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map(user => (
                            <tr key={user.id} style={{ borderBottom: '1px solid #222' }}>
                                <td style={{ padding: '20px' }}>{user.displayName || user.id.substring(0, 8)}</td>
                                <td style={{ padding: '20px', color: '#aaa' }}>{user.email || 'N/A'}</td>
                                <td style={{ padding: '20px' }}>
                                    {editingUser === user.id ? (
                                        <input
                                            type="number"
                                            value={newCredits}
                                            onChange={(e) => setNewCredits(e.target.value)}
                                            style={{
                                                width: '80px',
                                                padding: '8px',
                                                borderRadius: '5px',
                                                background: '#222',
                                                color: '#fff',
                                                border: '1px solid #444'
                                            }}
                                        />
                                    ) : (
                                        <span style={{ fontWeight: 'bold', color: '#00c6ff' }}>{user.walletBalance || 0}</span>
                                    )}
                                </td>
                                <td style={{ padding: '20px', color: '#666' }}>{user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'}</td>
                                <td style={{ padding: '20px' }}>
                                    {editingUser === user.id ? (
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button onClick={() => handleUpdateCredits(user.id)} style={{ padding: '8px 15px', background: '#28a745', border: 'none', borderRadius: '5px', color: '#fff', cursor: 'pointer' }}>Save</button>
                                            <button onClick={() => setEditingUser(null)} style={{ padding: '8px 15px', background: '#dc3545', border: 'none', borderRadius: '5px', color: '#fff', cursor: 'pointer' }}>Cancel</button>
                                        </div>
                                    ) : (
                                        <button onClick={() => { setEditingUser(user.id); setNewCredits(user.walletBalance || 0); }} style={{ padding: '8px 15px', background: 'transparent', border: '1px solid #00c6ff', borderRadius: '5px', color: '#00c6ff', cursor: 'pointer' }}>Edit Credits</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminPage;
